<template>
  <!--退换货申请页面-->
  <tk-container
    :probeType="3"
    :status="status"
    hide-status-bar
    class="apply-return-bg"
    :style="`background-image: url(${orderImage}) !important`"
    @scroll="watchScroll"
  >
    <!--头部-->
    <gradient-header slot="header" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'fanhui'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">退换货申请</div>
    </gradient-header>
    <!--背景图片渲染-->
    <div class="content-box">
      <div class="m-l-15 font-20 font-bold text-white">退换货申请</div>
      <!--退换货选择-->
      <div class="m-x-12 m-t-10">
        <tk-card
          :height="50"
          :width="100"
          class="p-y-8"
          :is-middle="true"
        >
          <tk-flex
            between middle
            @click.native="selectedType(index)"
            class="font-14 full-width"
            v-for="(s, index) in typeList"
            :class="{'m-t-10': index !== 0}"
            :key="index"
          >
            <tk-flex middle>
              <tk-icon size="22" color="#D51D16">{{s.icon}}</tk-icon>
              <span class="m-l-12">{{s.text}}</span>
            </tk-flex>
            <tkui-toggle type="round" v-model="s.isSelected"></tkui-toggle>
          </tk-flex>
        </tk-card>
      </div>
    </div>
    <!--问题描述·图片-->
    <div class="m-x-12 m-t-10">
      <card :height="100" :width="100">
        <div class="font-bold font-14">问题描述</div>
        <textarea name="hehe" id="text-input" cols="30" rows="4" v-model="detailedReason"
                  class="text-input m-t-10" placeholder="申请退换货具体原因"></textarea>
        <three-image-post class="m-t-10 p-0" :sign-width="80" @postImage="receiveParams"></three-image-post>
      </card>
    </div>
    <tkui-button
      :disabled="applyDisabled"
      @click="applyNow"
      class="raised m-t-24 primary block rounded surePrint"
    >提交</tkui-button>
  </tk-container>
</template>

<script>
import threeImagePost from '@/components/threeImagePost'
export default {
  components: {
    threeImagePost
  },
  data () {
    return {
      status: false, // 页面状态
      isHeaderColor: false, // 判断头部颜色切换
      applyDisabled: false, // 提交按钮样式
      typeList: [ // 选择退换类型
        {
          icon: 'tuihuo',
          text: '申请退货',
          type: 'return',
          isSelected: true
        }, {
          icon: 'huanhuo',
          text: '申请换货',
          type: 'exchange',
          isSelected: false
        }
      ],
      type: 'return', // 选定的类型
      detailedReason: '', // 描述
      pictureCombination: [] // 图片
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 选定退换类型
     * @date: 2020/4/28
     */
    selectedType (index) {
      this.typeList.forEach(s => { s.isSelected = false })
      this.typeList[index].isSelected = true
      this.type = this.typeList[index].type
    },
    /**
     * @Description: 接收图片数组
     * @author xiaozan
     * @date 2020/5/3
     */
    receiveParams (arr) {
      this.pictureCombination = arr
    },
    /**
     * @Description: 提交申请
     * @author xiaozan
     * @date 2020/5/4
     */
    async applyNow () {
      if (!this.detailedReason) { return this.$tkGlobal.toast.add('问题描述不能为空') }
      if (!this.pictureCombination.length) { return this.$tkGlobal.toast.add('问题图片不能为空') }
      let sum = await this.statisticsNum('returnExchangeRecords',
        { order: this.$route.query.id, user: this.userInfo.objectId })
      if (sum > 0) {
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复提交')
      }
      this.status = 'waiting'
      this.applyDisabled = true
      let obj = {
        type: this.type,
        detailedReason: this.detailedReason,
        order: this.$route.query.id,
        pictureCombination: this.pictureCombination,
        status: 'submitted',
        user: {
          objectId: this.userInfo.objectId,
          __type: 'Pointer',
          className: '_User'
        }
      }
      await this.$tkParse.post(`/classes/returnExchangeRecords`, obj).catch(() => {
        this.status = false
        this.applyDisabled = false
        throw this.$tkGlobal.toast.add('提交退换货申请失败')
      })
      await this.$tkParse.put(`/classes/order/${this.$route.query.id}`, { status: 'returnExchange', isApplyReturn: true })
      let orderDetail = await this.$tkParse.getData(`/classes/order/${this.$route.query.id}`)
      this.$setFlash('orderEdit', { id: orderDetail.objectId, status: orderDetail.status })
      this.$store.commit('setOrderMiddleValue', { id: orderDetail.objectId, status: 'returnExchange', type: 'myOrder' })
      await this.$tkHelper.sleep(500)
      this.$tkGlobal.toast.add('提交退换货申请成功，请耐心等待')
      this.$back()
      this.status = false
      this.applyDisabled = false
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .header-editor {
    width: 60px;
    height: 30px;
    line-height: 30px;
  }
  .apply-return-bg {
    background-repeat: no-repeat !important;
    background-size: 100% 180px !important;
    background-attachment: fixed !important;
    min-height: 180px;
  }
  /*后台数据渲染样式*/
  .content-box {
    /*background-position: center center;*/
    padding-top: 70px;
  }
  .text-input {
    height: 100%;
    width: 100%;
    min-width: 0;
  }
  .text-input::placeholder {
    font-size: 14px;
    color: rgba(191, 191, 191, 1);
  }
</style>
